import React from "react";

const AnalyticsContext = React.createContext({});

export default AnalyticsContext;
